import * as types from '../../types'
import Immutable from 'immutable'

const INITIAL_STATE = Immutable.fromJS({
    user: null,
    username: '',
    password: '',
    processing: false,
    isAuthenticated: false,
})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.SIGNIN_INICIAR_SESION:
            state = state.set('isAuthenticated', true)
            return state
        case types.SIGNIN_CERRAR_SESION:
            state = state.set('isAuthenticated', false)
            return state
        case types.SIGNIN_PROCESANDO:
            state = state.set('processing', action.payload)
            if (!action.payload) state = state.set('password', '')
            return state
        case types.SIGNIN_ASIGNAR_USUARIO_SESION:
            state = state.set('user', Immutable.fromJS(action.payload))
            return state
        default:
            return state
    }
}